<div>
  <ems-toast-message *ngIf="!uploadService.showErrorMsg && !(sharedService.errorMessage | async)" #toastMessage>
  </ems-toast-message>

  <ems-service-error *ngIf="sharedService.errorMessage | async"></ems-service-error>

  <sdps-notification type="error" class="sdps-m-top_none" *ngIf="uploadService.showErrorMsg">
    <div class="sdps-notification__text">
      <p *ngIf="uploadService.showErrorMsg" [innerHTML]="getConstant.uploadListPage.exportFailureMsg"></p>
    </div>
  </sdps-notification>

  <sdps-notification type="error" class="sdps-m-top_none" *ngIf="filterBtnDisableForsubmittedBy || filterBtnDisableForfileName ||
                    (uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').errors?.fileNamePatternCheck === false && uploadsListForm.get('fileName').errors?.emsStartSpacePattern !== false)">
    <div class="sdps-notification__text">
      <p [innerHTML]="addLinkConstant.pleaseCorrectFollowingError"></p>
      <ul class="sdps-navigation--horizontal__list error-list">
        <li *ngIf="filterBtnDisableForsubmittedBy || filterBtnDisableForfileName"
          [innerHTML]="getSharedConstant.textFieldErrorMsg.minCharLimitErrorMsg">
        </li>
        <li *ngIf="uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').invalid"
          [innerHTML]="getSharedConstant.textFieldErrorMsg.uploadsFileNameError">
        </li>
      </ul>
    </div>
  </sdps-notification>

  <h2 class="page-title sdps-m-bottom_large sdps-display-inline-block"
    [innerHTML]="getConstant.uploadListPage.uploadLabel"></h2>

  <span class="sdps-m-horizontal_large sdps-m-bottom_medium sdps-display-inline-block client-selection-indicator"
    [ngClass]="this.externalAccess ? 'external-access' : sharedService.showHistoricalView.value ? 'inactive-red' : (addlinkService.clientInformation | async)?.businessUnit | lowercase"
    [innerHTML]="(addlinkService.clientInformation | async)?.k4ClientName">
  </span>

  <ems-table-record-count class="tbl-rec-count" [count]="totalUploads" [showTotal]="totalUploads"
    (emitter)="pageObject.pageNo = 1;pageObject.pageSize = $event;applyFilter()" [showHeaderIcons]="true"
    [showRecords]="paginationCount && paginationCount > getSharedConstant.defaultTableRecords">
  </ems-table-record-count>

  <form [formGroup]="uploadsListForm" class="reportListMenu">
    <p-table [columns]="uploadListTableCols" [value]="uploadsList" metaKeySelection="true" [lazy]="true"
      (onLazyLoad)="customSort($event)" [customSort]="true" [multiSortMeta]="multiSortMeta" sortMode="multiple"
      class="common-data-table manage-client-list-table custom-table-filter">
      <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
        <span class="pi" [ngClass]="{
          'pi-sort': sortOrder === 0,
          'pi-caret-down': sortOrder === -1,
          'pi-caret-up': sortOrder === 1,
        }"></span>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr class="filter-header-input">
          <th class="table-checkbox-selection filter-icon" aria-label="Filter controls">
            <span class="sr-only">Filter controls</span>
            <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
              <em class="pi pi-filter" aria-hidden="true"></em>
            </button>
          </th>
          <th *ngFor="let col of columns" [attr.aria-label]="col.header || 'Column'" [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="col.field !== 'uploadId'"
            [ngClass]="[(col.field === 'uploadId' || col.field === 'submittedDate') ? 'w-10-per' : '', ((col.field=== 'fileName' || col.field=== 'submittedBy') ? 'w-15-per' : ''), (col.field === 'uploadId') ? 'column-min-width' : '', (paginationCount && paginationCount > 1 || filterClicked) ? 'pointer-events-auto' : 'pointer-events-none' , (col.field=== 'fileName' || col.field=== 'submittedBy') ? 'column-max-width' : '']">
            {{col.header || 'Column'}}
            <p-sortIcon [field]="col.field" *ngIf="col.field ==='uploadId' && (paginationCount && paginationCount > 1 || filterClicked)"></p-sortIcon>
          </th>
        </tr>

        <tr *ngIf="this.toggle" class="filtered-row-input">
          <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
          <th *ngFor="let col of columns" class="sdps-p-left_small" [attr.aria-label]="(col.header || 'Column') + ' filter'">
            <label class="sr-only" [for]="'upload_' + col.field" *ngIf="col.field === 'uploadId'">{{col.header || 'Upload ID'}} filter</label>
            <input pInputText [attr.aria-label]="col.header + ' filter'" [id]="'upload_' + col.field" formControlName="{{col.field}}" class="w-100-per" type="text" name="uploadId"
              (keydown.enter)="!(uploadsListForm.invalid) ? applyFilter() : ''" onkeypress="return (event.which >= 48 && event.which <= 57)"
              *ngIf="col.field === 'uploadId'">

            <label class="sr-only" [for]="'upload_' + col.field" *ngIf="col.field === 'fileName'">{{col.header || 'File Name'}} filter</label>
            <input pInputText [attr.aria-label]="col.header + ' filter'" [id]="'upload_' + col.field" formControlName="{{col.field}}" class="w-100-per" type="text" name="fileName"
              *ngIf="col.field === 'fileName'" emsUploadsFileNamePatterncheck emsStartSpaceValidator
              (keydown.enter)="!(uploadsListForm.invalid || (uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').invalid) || filterBtnDisableForsubmittedBy || filterBtnDisableForfileName) ? applyFilter() : ''"
              onkeydown="return (event.keyCode !== 13);"
               [ngClass]="{'invalidField': (filterBtnDisableForfileName || (uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').invalid)), 'disabled': filterState === 'disable'}">

            <label class="sr-only" [for]="'upload_' + col.field" *ngIf="col.field === 'submittedBy'">{{col.header || 'Submitted By'}} filter</label>
            <input pInputText [attr.aria-label]="col.header + ' filter'" [id]="'upload_' + col.field" formControlName="{{col.field}}" class="w-100-per" type="text" name="submittedBy"
              (keydown.enter)="!(uploadsListForm.invalid || (uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').invalid) || filterBtnDisableForsubmittedBy || filterBtnDisableForfileName || uploadsListForm.get('submittedBy').invalid) ? applyFilter() : ''"
              onkeydown="return (event.keyCode !== 13);" *ngIf="col.field === 'submittedBy'"
              emsStartSpaceValidator [ngClass]="{'invalidField': (filterBtnDisableForsubmittedBy || uploadsListForm.get('submittedBy').invalid), 'disabled': filterState === 'disable'}">

            <div class="timePickerForm upload-type" *ngIf="col.enum === 'dropdown'">
              <label class="sr-only" [for]="'upload_' + col.field">{{col.header || 'Upload Type'}} filter</label>
              <p-select appendTo="body" [inputId]="'upload_' + col.field" [attr.aria-label]="col.header + ' filter'" [options]="uploadTypeDropdownValue" placeholder=" " formControlName="{{col.field}}"
                          class="editableTimepicker request-list-header-dropdown" optionLabel="label">
              </p-select>
            </div>

            <div *ngIf="col.enum === 'multiselect'"
              class="col-2 emtr-dropdown upload-status timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multiselect">
              <label class="sr-only" [for]="'upload_' + col.field">{{col.header || 'Status'}} filter</label>
              <p-multiSelect appendTo="body" [inputId]="'upload_' + col.field" [attr.aria-label]="col.header + ' filter'" formControlName="{{col.field}}"
                [options]="getConstant.uploadListPage.uploadsListFilter[col.field]" [filter]="true" [defaultLabel]="' '"
                [displaySelectedLabel]="true" [maxSelectedLabels]="1" [showHeader]="true" [filterPlaceHolder]="'All'"
                [filter]="true">
              </p-multiSelect>
            </div>

            <div *ngIf="col.enum === 'dateRange'">
              <ems-date-range-filter id="upload_calendar" #range [disableForm]="filterState === 'disable'" dateFilterLabel="Submitted date filter"
                (submittedDate)="getSelectedDate($event);" [limitCustomRangeTo6Months]="true"></ems-date-range-filter>
            </div>

            <div *ngIf="col.field === 'action'" class="sdps-p-right_none w-200-px">
              <button class="buttons button-filter"
                [innerHTML]="getConstant.uploadListPage.uploadsListFilter.clearButton"
                [disabled]="!uploadsListForm.dirty && !isSortingChanged"
                (click)="isClearBtnClicked = true;filterClicked? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged); clearSuccessAndErrorMessages();"></button>
              <button class="buttons button-save button-filter"
                [disabled]="(uploadsListForm.get('fileName').value && uploadsListForm.get('fileName').invalid) || filterBtnDisableForsubmittedBy || filterBtnDisableForfileName || uploadsListForm.get('submittedBy').invalid"
                (click)="applyFilter()" [innerHTML]="getConstant.uploadListPage.uploadsListFilter.applyButton"></button>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1" class="sdps-text-center"
            [innerHTML]="getConstant.manageUserPage.noRecords"></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td class="table-checkbox-selection filter-icon"></td>
          <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field !== 'action'"
            [ngClass]="[(col.field === 'uploadId' || col.field === 'submittedDate') ? 'w-10-per' : '', ((col.field=== 'fileName' || col.field=== 'submittedBy') ? 'w-15-per' : ''), (col.field=== 'clientName' || col.field=== 'fileName' || col.field=== 'submittedBy') ? 'word-break' : '', (col.field === 'action' || col.field === 'uploadId') ? 'column-min-width' : '', col.field=== 'fileName' || col.field=== 'submittedBy' ? 'column-max-width' : '']">
            <span *ngIf="col.field === 'uploadId'" [innerHTML]="rowData[col.field]"></span>
            <span *ngIf="col.field === 'clientName'" [innerHTML]="rowData[col.field]"></span>
            <span *ngIf="col.field === 'fileName'" [innerHTML]="rowData[col.field]"></span>
            <span *ngIf="col.field === 'uploadType'">
              <button type="button" class="btn-text-link" [innerHTML]="rowData[col.field]"
                (click)="navigateTo(rowData[col.field])" [attr.aria-label]="rowData[col.field]"></button>
            </span>
            <span *ngIf="col.field === 'submittedBy'" [innerHTML]="rowData[col.field]"></span>
            <span *ngIf="col.field === 'status'" class="status-column">
              <span class="status sdps-p-around-xx-large"
                *ngIf="rowData['status'] !== getConstant.uploadListPage.processingStatus"
                ngClass="{{rowData[col.field] | lowercase}}">
              </span>
              <span class="status-word-wrap sdps-m-left_x-small"
                *ngIf="rowData['status'] !== getConstant.uploadListPage.processingStatus"
                [innerHTML]="rowData[col.field] | titlecase"></span>
              <!-- <p-progressBar [value]="rowData['progressValue']" [ngClass]="{'custom-progressbar' : rowData['progressValue'] === 0}"
                *ngIf="rowData['status'] === getConstant.uploadListPage.processingStatus"></p-progressBar> -->
                <sdps-progress-indicator sdps-id="loader-determinate" *ngIf="rowData['status'] === getConstant.uploadListPage.processingStatus"
                 [attr.helper-text]="rowData['progressValue'] + '%'" [value]="rowData['progressValue']" max="100"
                 sdps-aria-describedby="loading-zone" sr-value-suffix="percent"></sdps-progress-indicator>
            </span>
            <span *ngIf="col.field === 'submittedDate'"
              [innerHTML]="rowData[col.field]? moment(rowData[col.field]).format('MM/DD/YYYY'): ''"></span>
          </td>
          </ng-container>
          <td>
            <div class="action-menu-dropdown">
              <button type="button" class="cursor sdps-p-around_xx-small"
                      [attr.aria-label]="'Upload actions for row ' + (rowData['submittedBy'] || rowData['uploadId'])"
                      aria-haspopup="menu"
                      [attr.aria-expanded]="uploadId===rowData['uploadId']"
                      [disabled]="rowData['status'] === this.getConstant.uploadListPage.processingStatus || rowData['status'].toUpperCase() === 'RECEIVED' || sharedService.hasUIVisibilityExclusionAction(getSharedConstant.visibilityUIComponents.UploadsActionMenu, 'DISABLE', 'upload')"
                      (click)="showActionMenu=true; uploadId=rowData['uploadId']; formMenuItem(rowData);"
                      [ngClass]="{'active-menu':uploadId===rowData['uploadId'], 'disable-overlay-menu': rowData['status'] === this.getConstant.uploadListPage.processingStatus || rowData['status'].toUpperCase() === 'RECEIVED' || sharedService.hasUIVisibilityExclusionAction(getSharedConstant.visibilityUIComponents.UploadsActionMenu, 'DISABLE', 'upload')}">
                <em class="pi pi-ellipsis-h sdps-p-around_xx-small" aria-hidden="true"></em>
              </button>
              <p-menu [model]="actionMenu"
                      *ngIf="uploadId===rowData['uploadId']"
                      class="menu-dropdown" (click)="onActionMenuClick($event, rowData)"></p-menu>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </form>

  <p-paginator #p *ngIf="paginationCount && paginationCount > getSharedConstant.defaultTableRecords" class="common-pagination" [rows]="pageObject.pageSize" [totalRecords]="paginationCount"
    (onPageChange)="paginate($event);"></p-paginator>
</div>

<app-uploads-modal #uploadsList *ngIf='uploadsList && uploadsList.length > 0' (exportID)=getExportID($event);>
</app-uploads-modal>
